import * as z from 'zod'

import {
  markList,
  optionalText,
  ownershipFields,
  requiredAmount,
  requiredDate,
  requiredText,
  tagList,
  withOwnership,
} from '../utils/schema'

export const realEstateSchema = withOwnership(z.object({
  ...ownershipFields(),
  assetName: requiredText('Name this property'),
  assetType: optionalText(),
  description: optionalText(),
  amount: requiredAmount('Enter the purchase price'),
  date: requiredDate('Enter the date of purchase'),
  currency: optionalText(),
  /* What the valuation step recorded, if anything. See markList. */
  prices: markList(),
  tags: tagList(),
}))

export type RealEstateValues = z.infer<typeof realEstateSchema>
